import React, { useState } from "react";
import ReactDOM from "react-dom";

import img from "../assets/images/sidom/svg/fondoCard.svg";
import play from "../assets/images/sidom/svg/play.svg";
import playOra from "../assets/images/sidom/svg/playOran.svg";

import defaultImage from "../assets/images/hero.jpg";

export default function CardTestimoClientes({
  title,
  title2,
  description,
  buttonText,
  image,
  youtubeUrl,
}) {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (e) => {
    e.preventDefault();
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  function getEmbedUrl(url) {
    if (!url) return null;

    if (url.includes("/embed/")) return url;

    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }
    return url;
  }
  const embedUrl = getEmbedUrl(youtubeUrl);

  return (
    <div className=" h-[400px] w-[350px]   rounded-lg shadow-lg relative overflow-hidden bg-sidom-blue dark:bg-sidom-gray text-sidom-light  dark:text-sidom-blue transition-colors duration-300 flex flex-col justify-center items-center p-4">
      <img
        src={img}
        alt="Fondo decorativo"
        className="absolute inset-0 z-0 opacity-90 -top-20 left-1/2  object-contain  pointer-events-none"
      />
      <div className="flex justify-center  items-center flex-col h-full relative z-10">
        <div className="z-10 flex flex-row items-center gap-4 mb-3">
          <div className="z-10  w-[50%]">
            <img
              src={
                image
                  ? `https://api.institucional.global.sidom.io${image}`
                  : defaultImage
              }
              alt={title}
              className="w-[100px] h-[100px] rounded-full object-cover border-2 border-sidom-dark shadow-md flex-shrink-0"
            />
          </div>

          <div className=" z-10 flex flex-col w-[50%] justify-start items-start">
            <h2 className="text-sm font-bold leading-tight ">{title}</h2>
            <h3 className="text-[11px] w-[150px] font-medium opacity-80 mb-4">
              {title2}
            </h3>

            <div className="relative ">
              {embedUrl ? (
                <>
                  <button
                    onClick={handleOpenModal}
                    className="relative inline-flex h-9 transition bg-sidom-orange  dark:bg-sidom-blue dark:text-sidom-light active:scale-95 overflow-hidden rounded-full p-[1px] focus:outline-none"
                  >
                    <div className="relative inline-flex  leading-snug h-full w-full items-center justify-start rounded-full px-2 text-nowrap text-sm font-bold gap-3">
                      Ver Video
                      <img
                        src={playOra}
                        alt="Logo "
                        className="hidden dark:block w-5"
                      />
                      <img
                        src={play}
                        alt="Logo "
                        className="block dark:hidden w-5"
                      />
                    </div>
                  </button>
                  {showModal &&
                    ReactDOM.createPortal(
                      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-70">
                        <div className="relative bg-sidom-blue rounded-lg shadow-lg p-4 flex flex-col items-center">
                          <button
                            onClick={handleCloseModal}
                            className="absolute top-2 right-2 text-white text-2xl font-bold hover:text-sidom-orange focus:outline-none"
                            aria-label="Cerrar"
                          >
                            ×
                          </button>
                          <iframe
                            width="560"
                            height="315"
                            src={embedUrl}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                            className="rounded-lg shadow-md"
                          ></iframe>
                        </div>
                      </div>,
                      document.body
                    )}
                </>
              ) : (
                <a
                  href="https://www.youtube.com/watch?v=J9oATQIj1Tg&feature=youtu.be"
                  className="relative inline-flex h-9 transition bg-sidom-orange  dark:bg-sidom-blue dark:text-sidom-light active:scale-95 overflow-hidden rounded-full p-[1px] focus:outline-none"
                >
                  <div className="relative inline-flex  leading-snug h-full w-full items-center justify-start rounded-full px-2 text-nowrap text-sm font-bold gap-3">
                    Ver Video
                    <img
                      src={playOra}
                      alt="Logo "
                      className="hidden dark:block w-5"
                    />
                    <img
                      src={play}
                      alt="Logo "
                      className="block dark:hidden w-5"
                    />
                  </div>
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="z-10 px-5 text-left">
          <p className="text-sm font-medium leading-3">
            <span className="text-lg font-bold">“</span>
            <span dangerouslySetInnerHTML={{ __html: description }} />
            <span className="text-lg font-bold">”</span>
          </p>
        </div>
      </div>
    </div>
  );
}
